import { render, staticRenderFns } from "./differDetail.vue?vue&type=template&id=4861d55f&scoped=true"
import script from "./differDetail.vue?vue&type=script&lang=js"
export * from "./differDetail.vue?vue&type=script&lang=js"
import style0 from "./differDetail.vue?vue&type=style&index=0&id=4861d55f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4861d55f",
  null
  
)

export default component.exports